import {
  IconHeart,
  IconCash,
  IconBuilding,
  IconUsers,
  IconUserPlus,
  IconHistory,
  IconListDetails,
  IconTicket,
} from '@tabler/icons-react';
import Routes from '@/router/Routes.ts';

export const goerNavData = [
  {
    title: 'goer_navbar.saved_gyms',
    path: Routes.GOER_SAVED_GYMS,
    icon: <IconHeart />,
  },
  {
    title: 'goer_navbar.day_passes',
    path: Routes.GOER_DAY_PASS_BOOKINGS,
    icon: <IconTicket />,
  },
];

export const ownerNavData = [
  {
    title: 'owner_navbar.listing_status',
    path: Routes.OWNER_LISTING_STATUS,
    icon: <IconBuilding />,
  },
  {
    title: 'owner_navbar.day_pass_sales',
    path: Routes.OWNER_DAY_PASS_BOOKINGS,
    icon: <IconTicket />,
  },
  {
    title: 'owner_navbar.subscription',
    path: Routes.OWNER_SUBSCRIPTION,
    icon: <IconCash />,
  },
];

export const adminNavData = [
  {
    title: 'admin_navbar.gym_owners',
    path: Routes.ADMIN_GYM_OWNERS,
    icon: <IconBuilding />,
  },
  {
    title: 'admin_navbar.gym_goers',
    path: Routes.ADMIN_GYM_GOERS,
    icon: <IconUsers />,
  },
  {
    title: 'admin_navbar.subscriptions',
    path: Routes.ADMIN_SUBSCRIPTIONS,
    icon: <IconCash />,
  },
  {
    title: 'admin_navbar.create_full_listing',
    path: Routes.ADMIN_CREATE_FULL_LISTING,
    icon: <IconListDetails />,
  },
  {
    title: 'admin_navbar.create_account',
    path: Routes.ADMIN_CREATE_ACCOUNT,
    icon: <IconUserPlus />,
  },
  {
    title: 'admin_navbar.audit_logs',
    path: Routes.ADMIN_AUDIT_LOGS,
    icon: <IconHistory />,
  },
];

